<div>
    @if (colorsPreset.length) {
        <label class="small">
            {{ "control_site_palette" | translate }}
        </label>
    }

    <div
        class="preset-area"
        role="group"
        [attr.aria-label]="'control_palette' | translate"
        (keydown)="onKeydown($event)"
    >
        @if (colorsPreset.length) {
            <div class="cp-preset-colors-class mb-15">
                <button
                    #swatch
                    type="button"
                    class="preset-color"
                    [class.selected]="color === TRANSPARENT_VALUE"
                    [attr.aria-pressed]="color === TRANSPARENT_VALUE"
                    [attr.aria-label]="'control_transparent' | translate"
                    (click)="setColorHandler(TRANSPARENT_VALUE)"
                >
                    <img src="./assets/img/color-picker/opacity-icon.svg" alt="" />
                </button>
                @for (preset of colorsPreset; track $index) {
                    <button
                        #swatch
                        type="button"
                        class="preset-color"
                        [class.selected]="color === preset.value"
                        [attr.aria-pressed]="color === preset.value"
                        [attr.aria-label]="preset.name"
                        [style.background]="preset.value"
                        (click)="setColorPresetHandler(preset)"
                    >
                        <sp-transparent-icon [color]="preset.value" />
                    </button>
                }
                <button
                    #swatch
                    type="button"
                    class="preset-color"
                    [attr.aria-label]="'control_custom_color' | translate"
                    (click)="toggleShowCustom($event)"
                >
                    <img src="./assets/img/color-picker/custom-icon.svg" alt="" />
                </button>
            </div>
        }

        <label class="small">{{ "control_palette" | translate }}</label>
        @if (!colorsPreset.length) {
            <div class="cp-preset-colors-class mb-15 justify-content-start">
                <button
                    #swatch
                    type="button"
                    class="preset-color mr-5"
                    [class.selected]="color === TRANSPARENT_VALUE"
                    [attr.aria-pressed]="color === TRANSPARENT_VALUE"
                    [attr.aria-label]="'control_transparent' | translate"
                    (click)="setColorHandler(TRANSPARENT_VALUE)"
                >
                    <img src="./assets/img/color-picker/opacity-icon.svg" alt="" />
                </button>
                <button
                    #swatch
                    type="button"
                    class="preset-color"
                    [attr.aria-label]="'control_custom_color' | translate"
                    (click)="toggleShowCustom($event)"
                >
                    <img src="./assets/img/color-picker/custom-icon.svg" alt="" />
                </button>
            </div>
        }
        @for (preset of COLOR_PICKER_PRESETS; track $index) {
            <div class="cp-preset-colors-class">
                @for (value of preset; track $index) {
                    <button
                        #swatch
                        type="button"
                        class="preset-color"
                        [class.selected]="color === (value | lowercase)"
                        [attr.aria-pressed]="color === (value | lowercase)"
                        [attr.aria-label]="value"
                        [style.background]="value"
                        (click)="setColorHandler(value)"
                    ></button>
                }
            </div>
        }

        @if (!hideGradient) {
            <div class="margin-top-10">
                @for (preset of COLOR_PICKER_GRADIENT_PRESETS; track $index) {
                    <div class="cp-preset-colors-class">
                        @for (value of preset; track $index) {
                            <button
                                #swatch
                                type="button"
                                class="preset-color"
                                [class.selected]="color === (value | lowercase)"
                                [attr.aria-pressed]="color === (value | lowercase)"
                                [attr.aria-label]="value"
                                [style.background]="value"
                                (click)="setColorHandler(value)"
                            ></button>
                        }
                    </div>
                }
            </div>
        }
    </div>
</div>
